import { styled } from '@mui/material';
import { TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from '../../utils/constants/Constants.js';

var ProductGrid = styled('div', {
    shouldForwardProp: function (prop) { return !['containerWidthOverride'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var containerWidthOverride = _a.containerWidthOverride;
    return (_b = {
            display: 'grid',
            gridTemplateColumns: "repeat(".concat(containerWidthOverride ? 4 : 5, ", 1fr)"),
            justifyContent: 'space-between',
            gridGap: 20
        },
        _b["@media screen and (max-width: ".concat(1450, "px)")] = {
            gridTemplateColumns: "repeat(4, 1fr)",
        },
        _b["@media screen and (max-width: ".concat(1150, "px)")] = {
            gridTemplateColumns: "repeat(3, 1fr)",
        },
        _b["@media screen and (max-width: ".concat((TABLET_SCREEN_SIZE + MOBILE_SCREEN_SIZE) / 2, "px)")] = {
            gridTemplateColumns: "repeat(2, 1fr)",
            gridGap: 10,
        },
        _b);
});

export { ProductGrid };
//# sourceMappingURL=SearchResultsStyles.js.map
